import React from 'react';
import {createPortal} from 'react-dom';
import VideoModalContent from '@dazn/lp-web/src/components/VideoBanner/VideoModalContent';
import styles from '@dazn/lp-web/src/components/VideoBanner/video-banner.module.css';
import {useVideoBannerContext} from '@dazn/lp-web/src/components/VideoBanner/VideoBannerContext';
import {useModalRoot} from '@dazn/lp-web/src/hooks/useModalRoot';
import {useVideoBannerPlayer} from '@dazn/lp-web/src/components/VideoBanner/useVideoBannerPlayer';
import {PlayButtonBannerIcon} from '@dazn/lp-web/src/components/Icons';
import PlayIcon from '../PlayIcon/PlayIcon';
import {deviceDetector} from '../../utils/deviceDetector';
import {IVideo} from '../../types';

interface VideoModalProps {
    url: IVideo;
    title: string;
}

const VideoModal: React.FC<VideoModalProps> = ({url, title}) => {
    const {showModal} = useVideoBannerContext();
    const modalRoot = useModalRoot('modal-root');

    const {handleBannerPlayButtonClick} = useVideoBannerPlayer();

    if (!modalRoot) return null;

    return (
        <>
            <button
                onClick={() => handleBannerPlayButtonClick(title)}
                className={styles.playButton}
            >
                {deviceDetector.isPhoneOnlyDevice ? (
                    <PlayIcon />
                ) : (
                    <PlayButtonBannerIcon />
                )}
            </button>
            {showModal &&
                createPortal(<VideoModalContent url={url} />, modalRoot)}
        </>
    );
};

export default VideoModal;
